import { Chip } from "@mui/material";
import { FoldersActions } from "actions";
import commonStyles, { folderColor } from "styles/common";

const ObjectVersion = (props: { index: number; object: any; setEntity: any; selected: boolean }) => {
    const { classes: common } = commonStyles();
    const { index, object, setEntity, selected } = props;
    const workflow = FoldersActions.getWorkflowFromEntity(object) || [];
    return (
        <div
            className={common.middle}
            style={{ cursor: "pointer", height: 30 }}
            onClick={() => setEntity(index, object)}
        >
            <Chip
                label={workflow["version"]}
                size="small"
                title={workflow["comment"]}
                style={{ marginLeft: 7, backgroundColor: selected ? "#f9aeae" : folderColor }}
            />
        </div>
    );
};

export default ObjectVersion;
